import * as React from "react";
const SvgIcViewInfoHover = props => <svg xmlns="http://www.w3.org/2000/svg" width={16} height={16} viewBox="0 0 16 16" {...props}><path fill="#4c4c52" d="M7 12h2V7H7zM8 0c4.4 0 8 3.6 8 8s-3.6 8-8 8-8-3.6-8-8 3.6-8 8-8M7 4v2h2V4z" /></svg>;
export default SvgIcViewInfoHover;